import { TAGLIST_SEARCH, TAGLIST_PAGE } from '../actions/taglistactions';

const state = { search: '', page: 0 };

const getters = {
    page: state => state.page,
    search: state => state.search
};

const actions = {
    [TAGLIST_SEARCH]: ({ commit }, search) => {
        commit(TAGLIST_SEARCH, search);
    },
    [TAGLIST_PAGE]: ({ commit }, page) => {
        commit(TAGLIST_PAGE, page);
    }
};

const mutations = {
    [TAGLIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [TAGLIST_PAGE]: (state, page) => {
        state.page = page;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};